export default __webpack_public_path__ + "static/media/EwWelJGWEAAR56k.e000260d.jpeg";